// from general.js
/* global trim */
// from JSP?
/* global userId teacherId */


/**
 * Retina classroom photo currently appears on project page and teacher page with the following assumptons:
 * -- the image area should be hidden if it's a fallback image and the user is not the teacher
 * -- Or if it's the teacher, the fallback image is shown with an upload link
 */
function fallbackForRetinaClassroomPhotoBG() {
    if ($('.js-classroom-photo-format-retina-bg').length > 0) {
        let photoSrc = $('.js-classroom-photo-format-retina-bg').css('background-image');
        try {
            photoSrc = photoSrc.match(/\((.*?)\)/)[1].replace(/(['"])/g, '');
            if (trim(photoSrc) != '') {
                $('<img />').attr('src', photoSrc).on('error', function () {
                    $('.js-classroom-photo-format-retina-bg').css('background-image', 'url(' + baseCacheURL + 'images/classroom/fallback-classroom@2x.png)');
                    decorateFallbackForRetinaClassroomPhotoBG();
                });
            }
        } catch (e) {
            $('.js-classroom-photo-format-retina-bg').css('background-image', 'url(' + baseCacheURL + 'images/classroom/fallback-classroom@2x.png)');
        }
    }
}

export const decorateFallbackForRetinaClassroomPhotoBG = window.decorateFallbackForRetinaClassroomPhotoBG = function () {
    if ($('.js-classroom-photo-format-retina-bg').length > 0 && $('.js-classroom-photo-format-retina-bg').css('background-image').indexOf('images/classroom/fallback-classroom') === -1) {
        $('.js-classroom-photo-format-retina-bg').show();
        const photoUploadButton = $('.js-classroom-photo-upload');
        if (!photoUploadButton.has('.tpc-review')) {
            $('.js-classroom-photo-upload').hide();
        }
        $('.js-classroom-photo-format-retina-bg').next('.teacher-photo').removeClass('fix-margin').removeClass('sole-photo');
        if (typeof teacherId === 'undefined' || teacherId != userId) {
            $('.js-classroom-photo-upload').hide();
        }
    } else if (typeof teacherId !== 'undefined' && teacherId == userId) {
        // add edit links
        $('.js-classroom-photo-format-retina-bg').each(function () {
            const link = secureBaseURL + 'teacher/teacher_photo_upload.html';
            if ($(this).closest('.js-classroom-photo-upload').length === 0) {
                if ($(this).prop('tagName').toLowerCase() === 'a') {
                    $(this).addClass('js-classroom-photo-upload upload');
                    $('a.js-classroom-photo-upload').attr('aria-label', 'Upload classroom photo');
                    $('a.js-classroom-photo-upload').attr('title', 'Upload a photo of your classroom.');
                    $('a.js-classroom-photo-upload').attr('href', secureBaseURL + 'teacher/teacher_photo_upload.html');
                    $('a.js-classroom-photo-upload').css('pointer-events', 'auto');
                    $('a.js-classroom-photo-upload').html('Upload a classroom photo');
                } else {
                    $(this).wrap('<a href="' + link + '" class="js-classroom-photo-upload" title="Please consider uploading a new photo of your classroom."></a>');
                }
            }
        });
        $('.js-classroom-photo-format-retina-bg').show();
        $('.js-classroom-photo-upload').show();
        $('.js-classroom-photo-format-retina-bg').next('.teacher-photo').removeClass('fix-margin').removeClass('sole-photo');
    } else {
        $('.js-classroom-photo-format-retina-bg').hide();
        const photoUploadButton = $('.js-classroom-photo-upload');
        if (!photoUploadButton.has('.tpc-review')) {
            $('.js-classroom-photo-upload').hide();
        }
        $('.js-classroom-photo-format-retina-bg').next('.teacher-photo').addClass('fix-margin').addClass('sole-photo');
    }
};

$(document).ready(function () {
    decorateFallbackForRetinaClassroomPhotoBG();
    fallbackForRetinaClassroomPhotoBG();
});
